{
  "language": {
    "title": "Elige tu idioma",
    "en": "English",
    "en_US": "English",
    "nl": "Nederlands",
    "sr": "Srpski",
    "fr": "Français",
    "de": "Deutsch",
    "pt": "Português",
    "es": "Español",
    "ja": "日本語",
    "pl": "Polski",
    "it": "Italiano"
  },
  "home": {
    "welcomeMessage": "Hola, ¿cómo podemos ayudarte?",
    "checkIn": "Registrar entrada",
    "independentManualCheckIn": "Sin cita",
    "integratedManualCheckIn": "Registrar entrada manualmente",
    "checkOut": "Registrar salida",
    "manualCheckOut": "Registrar salida manualmente",
    "parcelDelivery": "Entrega de paquetes",
    "foodDelivery": "Entrega de comida",
    "callReception": "Llamar a recepción",
    "overview": "Resumen",
    "unavailable": "La recepción no está disponible en este momento."
  },
  "check": {
    "option": {
      "checkin": {
        "title": "Elige una opción para registrar entrada",
        "manual": "Registrar entrada manualmente",
        "code": "Registrar entrada con PIN o código QR",
        "code-no-qr": "Registrar entrada con código PIN"
      },
      "checkout": {
        "title": "Elige una opción para registrar salida",
        "manual": "Registrar salida con nombre",
        "code": "Registrar salida con PIN o código QR",
        "code-no-qr": "Registrar salida con código PIN"
      }
    },
    "title": "Ahora puedes escanear tu código QR o ingresar tu código PIN.",
    "orText": "O",
    "qrScanner": {
      "checkin": {
        "title": "Elige una opción para registrar entrada"
      },
      "checkout": {
        "title": "Elige una opción para registrar salida"
      },
      "btn": "Escanear código QR"
    },
    "hidScanner": {
      "title": "Acerca el código QR al escáner de abajo o introduce tu código PIN"
    },
    "pinOnly": {
      "title": "Por favor, introduce tu código PIN"
    },
    "pinCode": "Ingresa tu código PIN",
    "manually": {
      "checkin": "¿No tienes un código de registro?"
    },
    "status": {
      "idle": {
        "title": "Tu código se está escaneando.",
        "message": "Por favor espera...",
        "nfc": {
          "title": "Su etiqueta se está escaneando.",
          "message": "Por favor, espere..."
        }
      },
      "loading": {
        "title": "Tu código se está escaneando.",
        "message": "Por favor espera...",
        "nfc": {
          "title": "Su etiqueta se está escaneando.",
          "message": "Por favor, espere..."
        }
      },
      "error": {
        "title": "Tu código no es válido.",
        "message": "¡Por favor inténtalo de nuevo!",
        "nfc": {
          "title": "Su etiqueta no es válida.",
          "message": "¡Por favor, inténtelo de nuevo!"
        },
        "meeting": {
          "tooEarly": {
            "title": "Llegaste un poco temprano",
            "message": "Tu código es válido a partir de las {{validFromTime}}. La reunión comienza a las {{meetingStartTime}}."
          },
          "tooLate": {
            "title": "Este código ha caducado",
            "message": "La reunión terminó a las {{meetingEndTime}}. Tu código era válido hasta las {{validUntilTime}}."
          }
        }
      },
      "success": {
        "checkin": {
          "default": {
            "title": "Te has registrado exitosamente.",
            "message": "Gracias."
          },
          "MeetingAttendee": {
            "no-email-sms": {
              "title": "Te has registrado exitosamente.",
              "message": "Gracias."
            },
            "email-sms": {
              "title": "Te has registrado exitosamente.",
              "message": "Tu persona de contacto ha sido notificada."
            },
            "call-ping": {
              "title": "Te has registrado exitosamente.",
              "message": "Ahora estableceremos una llamada telefónica con tu persona de contacto."
            },
            "teams-call": {
              "title": "Te has registrado exitosamente.",
              "message": "Ahora estableceremos una llamada de Microsoft Teams con tu persona de contacto."
            },
            "badge": {
              "title": "Gracias por registrarte, tu credencial será impresa.",
              "message": ""
            },
            "video-call": {
              "title": "Te has registrado exitosamente.",
              "message": "Configurando su videollamada con la persona de contacto."
            }
          },
          "Employee": {
            "title": "Te has registrado exitosamente.",
            "message": "Gracias.",
            "badge": {
              "title": "Gracias por registrarte, tu credencial será impresa.",
              "message": ""
            }
          },
          "Visitor": {
            "title": "Te has registrado exitosamente.",
            "message": "Gracias.",
            "badge": {
              "title": "Gracias por registrarte, tu credencial será impresa.",
              "message": ""
            }
          }
        },
        "checkout": {
          "default": {
            "title": "Has registrado tu salida exitosamente.<br/>",
            "message": "Te vemos pronto."
          },
          "MeetingAttendee": {
            "title": "Has registrado tu salida exitosamente.",
            "message": "Te vemos pronto."
          },
          "Employee": {
            "title": "Has registrado tu salida exitosamente.",
            "message": "Te vemos pronto."
          },
          "Visitor": {
            "title": "Has registrado tu salida exitosamente.",
            "message": "Te vemos pronto."
          },
          "access": {
            "title": "Has registrado tu salida exitosamente.",
            "message": "Ahora puedes abrir la puerta."
          }
        }
      }
    }
  },
  "missingFields": {
    "title": "Algunos datos más antes del check-in",
    "subtitle": "Los campos marcados con * son obligatorios",
    "btn": "Registrar entrada",
    "placeholder": {
      "other": "Otro...",
      "otherInput": "Introduzca su opción"
    },
    "error": {
      "required": "No has rellenado este campo",
      "email": "Dirección de correo electrónico no válida",
      "phone": "Número de teléfono no válido"
    }
  },
  "manualCheckin": {
    "title": {
      "default": "Por favor completa.",
      "documentScanner": "Preste atención al insertar su documento de identidad:"
    },
    "subtitle": {
      "default": "Nota - todos los campos * son obligatorio",
      "documentScanner": [
        {
          "parts": [
            { "text": "El ", "bold": false },
            { "text": "lado con los caracteres <<< >>> (MRZ) ", "bold": true },
            { "text": "debe estar ", "bold": false },
            { "text": "orientado hacia el quiosco / escáner.", "bold": true }
          ]
        },
        {
          "parts": [
            { "text": "Mantenga la tarjeta quieta ", "bold": false },
            {
              "text": "hasta que los campos se completen automáticamente.",
              "bold": true
            }
          ]
        }
      ]
    },
    "noOption": "Sin opción",
    "btn": "Registrar entrada",
    "placeholder": {
      "name": "Tu nombre *",
      "email": "Tu correo electrónico *",
      "phone": "Número de móvil",
      "contactName": "Tu persona de contacto*",
      "other": "Otro..."
    },
    "error": {
      "required": "No completaste este campo",
      "name": "Nombre inválido",
      "email": "Dirección de correo electrónico inválida",
      "phone": "Número de móvil inválido"
    },
    "status": {
      "idle": {
        "no-contact": {
          "title": "Por favor espera...",
          "message": "Tu registro está siendo procesado."
        },
        "contact": {
          "title": "Por favor espera...",
          "message": "Tu contacto está siendo notificado."
        }
      },
      "loading": {
        "no-contact": {
          "title": "Por favor espera...",
          "message": "Tu registro está siendo procesado."
        },
        "contact": {
          "title": "Por favor espera...",
          "message": "Tu contacto está siendo notificado."
        }
      },
      "success": {
        "no-email-sms": {
          "title": "Te has registrado exitosamente.",
          "message": "Gracias."
        },
        "email-sms": {
          "title": "Te has registrado exitosamente.",
          "message": "Tu persona de contacto ha sido notificada."
        },
        "call-ping": {
          "title": "Te has registrado exitosamente.",
          "message": "Ahora estableceremos una llamada telefónica con tu persona de contacto."
        },
        "teams-call": {
          "title": "Te has registrado exitosamente.",
          "message": "Ahora estableceremos una llamada de Microsoft Teams con tu persona de contacto."
        },
        "badge": {
          "title": "Gracias por registrarte, tu credencial será impresa.",
          "message": ""
        },
        "video-call": {
          "title": "Te has registrado exitosamente.",
          "message": "Configurando su videollamada con la persona de contacto."
        }
      },
      "error": {
        "title": "Algo salió mal.",
        "message": "¡Por favor inténtalo de nuevo!"
      }
    },
    "documentScan": {
      "invalid": {
        "title": "Documento no válido",
        "message": "El documento no pudo ser verificado o ha caducado. Por favor, introduzca sus datos manualmente."
      }
    }
  },
  "manualCheckout": {
    "title": "Ingresa tu nombre para registrar salida",
    "btn": "Registrar salida",
    "form": {
      "placeholder": {
        "name": "Tu nombre completo *"
      },
      "loading": "Cargando...",
      "noOptions": "Sin opciones"
    },
    "error": {
      "required": "No completaste este campo",
      "name": "Nombre inválido"
    },
    "status": {
      "idle": {
        "title": "Estamos procesando tu información.",
        "message": "Por favor espera..."
      },
      "loading": {
        "title": "Estamos procesando tu información.",
        "message": "Por favor espera..."
      },
      "success": {
        "title": "Has registrado tu salida exitosamente.",
        "message": "Gracias y que tengas un buen día."
      },
      "successAccess": {
        "title": "Has registrado tu salida exitosamente.",
        "message": "Ahora puedes abrir la puerta."
      },
      "error": {
        "title": "Ocurrió un error al registrar la salida.",
        "message": "¡Por favor inténtalo de nuevo!"
      }
    }
  },
  "call": {
    "title": {
      "no-email-sms": "¿Te gustaría notificar a tu contacto?",
      "email-sms": "Hemos enviado un correo electrónico/SMS a tu contacto.<br/>¿Quieres establecer una llamada con ellos adicionalmente?"
    },
    "callBtn": "Llamar",
    "pingBtn": "Ping",
    "smsBtn": "SMS",
    "callVideoBtn": "Videollamada",
    "teamsCallBtn": "Llamada de Teams",
    "teamsMessageBtn": "Mensaje de Teams",
    "googleChatMessageBtn": "Google Chat",
    "noBtn": "Cancelar",
    "cancelBtn": "Cancelar llamada",
    "status": {
      "connecting": {
        "title": "Estableciendo llamada.<br/>Por favor espera...",
        "message": ""
      },
      "ringing": {
        "title": "Llamando a tu persona de contacto<br/>Por favor espera...",
        "message": ""
      },
      "ringingReception": {
        "title": "Llamada iniciada...",
        "message": ""
      },
      "open": {
        "title": "Llamada en curso.",
        "message": ""
      },
      "close": {
        "title": "Llamada finalizada.<br/>",
        "message": ""
      },
      "closeAccess": {
        "title": "Llamada finalizada.<br/>Ahora puedes abrir la puerta.",
        "message": ""
      },
      "closeReception": {
        "title": "La llamada ha finalizado.",
        "message": ""
      },
      "error": {
        "title": "No se pudo establecer la llamada.<br/>¿Llamar de nuevo?",
        "message": ""
      }
    }
  },
  "message": {
    "status": {
      "idle": {
        "title": "Estamos notificando a tu persona de contacto.",
        "message": "Por favor espera..."
      },
      "loading": {
        "title": "Estamos notificando a tu persona de contacto.",
        "message": "Por favor espera..."
      },
      "success": {
        "title": "El SMS ha sido enviado. El contacto ha sido notificado.",
        "message": "¡Gracias!"
      },
      "successAccess": {
        "title": "El SMS ha sido enviado. El contacto ha sido notificado.",
        "message": "Ahora puedes abrir la puerta."
      },
      "error": {
        "title": "SMS no enviado.",
        "message": "¡Por favor inténtalo de nuevo!"
      }
    }
  },
  "videoCall": {
    "title": "Videollamada",
    "endCall": "Finalizar llamada",
    "status": {
      "idle": {
        "title": "Estamos creando una sala de video.",
        "message": "Por favor espera..."
      },
      "loading": {
        "title": "Estamos creando una sala de video.",
        "message": "Por favor espera..."
      },
      "success": {
        "title": "La sala de video ha sido creada exitosamente.",
        "message": "Uniéndose a la sala..."
      },
      "error": {
        "title": "La sala de video no fue creada exitosamente.",
        "message": "¡Por favor inténtalo de nuevo!"
      }
    }
  },
  "teamsCall": {
    "title": "Llamada de Teams",
    "controls": {
      "startCall": "Iniciar llamada",
      "endCall": "Salir",
      "camera": "Cámara",
      "cameraOff": "Cámara apagada",
      "mic": "Micrófono",
      "micOff": "Micrófono apagado",
      "ringing": "Sonando...",
      "noAnswer": "Nadie ha contestado la llamada."
    },
    "status": {
      "connecting": {
        "title": "Estableciendo llamada.<br/>Por favor espera...",
        "message": ""
      },
      "ringing": {
        "title": "Llamando a tu persona de contacto<br/>Por favor espera...",
        "message": ""
      },
      "connected": {
        "title": "Estableciendo llamada",
        "message": ""
      },
      "disconnected": {
        "title": "Llamada finalizada.<br/>",
        "message": ""
      },
      "disconnectedAccess": {
        "title": "Llamada finalizada.<br/>Ahora puedes abrir la puerta.",
        "message": ""
      },
      "error": {
        "title": "No se pudo establecer la llamada.<br/>Por favor inténtalo de nuevo",
        "message": ""
      },
      "noAnswer": {
        "title": "Nadie contestó la llamada.<br/>Por favor inténtalo de nuevo.",
        "message": ""
      }
    }
  },
  "teamsMessage": {
    "status": {
      "idle": {
        "title": "Estamos notificando a tu persona de contacto.",
        "message": "Por favor espera..."
      },
      "loading": {
        "title": "Estamos notificando a tu persona de contacto.",
        "message": "Por favor espera..."
      },
      "success": {
        "title": "El mensaje ha sido enviado. El contacto ha sido notificado.",
        "message": "¡Gracias!"
      },
      "successAccess": {
        "title": "El mensaje ha sido enviado. El contacto ha sido notificado.",
        "message": "Ahora puedes abrir la puerta."
      },
      "error": {
        "title": "Mensaje no enviado.",
        "message": "¡Por favor inténtalo de nuevo!"
      }
    }
  },
  "googleChatMessage": {
    "status": {
      "idle": {
        "title": "Estamos notificando a tu persona de contacto.",
        "message": "Por favor espera..."
      },
      "loading": {
        "title": "Estamos notificando a tu persona de contacto.",
        "message": "Por favor espera..."
      },
      "success": {
        "title": "El mensaje ha sido enviado. El contacto ha sido notificado.",
        "message": "¡Gracias!"
      },
      "successAccess": {
        "title": "El mensaje ha sido enviado. El contacto ha sido notificado.",
        "message": "Ahora puedes abrir la puerta."
      },
      "error": {
        "title": "Mensaje no enviado.",
        "message": "¡Por favor inténtalo de nuevo!"
      }
    }
  },
  "packageDelivery": {
    "title": "¡Qué amable de tu parte entregar un paquete!",
    "subtitle": "Selecciona y notifica al destinatario",
    "subtitle1": "¡Presiona el botón de abajo para hacernos saber que estás aquí!",
    "subtitle2": "",
    "input": {
      "label": {
        "contact": "¿Para quién es el paquete?"
      },
      "error": {
        "contact": {
          "required": "No completaste este campo"
        }
      }
    },
    "button": {
      "submit": "Notificar"
    },
    "status": {
      "loading": {
        "title": "Estamos notificando a la persona de contacto.",
        "message": "Por favor espera..."
      },
      "success": {
        "no-email-sms": {
          "title": "¡Gracias por tu entrega!",
          "message": ""
        },
        "email-sms": {
          "title": "La persona de contacto ha sido notificada.",
          "message": "¡Gracias por tu entrega!"
        },
        "call-ping": {
          "title": "¡Gracias por tu entrega!",
          "message": "Ahora se establecerá una conexión telefónica con la persona de contacto."
        },
        "teams-call": {
          "title": "¡Gracias por tu entrega!",
          "message": "Ahora se realizará una llamada de Microsoft Teams a tu persona de contacto."
        },
        "video-call": {
          "title": "¡Gracias por tu entrega!",
          "message": "Configurando su videollamada con la persona de contacto."
        }
      },
      "error": {
        "title": "Algo salió mal.",
        "message": "¡Por favor inténtalo de nuevo!"
      }
    }
  },
  "foodDelivery": {
    "title": "¡Qué amable de tu parte entregar comida!",
    "subtitle": "Selecciona y notifica al destinatario",
    "subtitle1": "¡Presiona el botón de abajo para hacernos saber que estás aquí!",
    "subtitle2": "",
    "input": {
      "label": {
        "contact": "¿Para quién es la comida?"
      },
      "error": {
        "contact": {
          "required": "No completaste este campo"
        }
      }
    },
    "button": {
      "submit": "Notificar"
    },
    "status": {
      "loading": {
        "title": "Estamos notificando al contacto.",
        "message": "¡Por favor espera!"
      },
      "success": {
        "no-email-sms": {
          "title": "¡Gracias por tu entrega!",
          "message": ""
        },
        "email-sms": {
          "title": "El contacto ha sido notificado.",
          "message": "¡Gracias por tu entrega!"
        },
        "call-ping": {
          "title": "¡Gracias por tu entrega!",
          "message": "Ahora se establecerá una conexión telefónica con tu persona de contacto."
        },
        "teams-call": {
          "title": "¡Gracias por tu entrega!",
          "message": "Ahora se realizará una llamada de Microsoft Teams a tu persona de contacto."
        },
        "video-call": {
          "title": "¡Gracias por tu entrega!",
          "message": "Configurando su videollamada con la persona de contacto."
        }
      },
      "error": {
        "title": "Algo salió mal.",
        "message": "¡Por favor inténtalo de nuevo!"
      }
    }
  },
  "QRCodeScanner": {
    "title": "Por favor escanea tu código QR",
    "subtitle": "Alinea el código QR dentro de las esquinas rojas y mantén tu teléfono estable.",
    "error": "Formato de código QR inválido",
    "unknownError": "Error desconocido ocurrió durante el escaneo"
  },
  "common": {
    "backBtn": "Atrás"
  },
  "previewPDF": {
    "page": {
      "of": "de",
      "previous": "Anterior",
      "next": "Siguiente"
    },
    "button": {
      "cancel": "Cancelar",
      "accept": "Aceptar",
      "next": "Siguiente"
    },
    "title": {
      "consent": "Consentimiento requerido"
    }
  },
  "offline": {
    "title": "Desconectado",
    "receptionMessage": "La recepción digital está desconectada en este momento y no puede ser utilizada, ¡la conexión a internet debe ser verificada!",
    "check": "¿Eres un visitante y quieres hablar directamente con un empleado? Por favor llama a {{receptionistPhone}}"
  },
  "overview": {
    "title": "¡Ingresa el código para abrir el resumen!",
    "noUsers": "Sin registros",
    "status": {
      "success": {
        "title": "El código es válido.",
        "message": ""
      },
      "error": {
        "title": "El código es inválido.",
        "message": "¡Por favor inténtalo de nuevo!"
      }
    },
    "checkoutStatus": {
      "loading": {
        "title": "Por favor espera...",
        "message": ""
      },
      "success": {
        "title": "Salida registrada exitosamente.",
        "message": ""
      },
      "error": {
        "title": "Algo salió mal.",
        "message": "¡Por favor inténtalo de nuevo!"
      }
    },
    "listTitle": "Lista de personas que registraron entrada hoy pero no registraron salida",
    "page": "Página ",
    "table": {
      "head": {
        "fullName": "Nombre",
        "type": "Tipo",
        "checkedinAt": "Registró entrada a las",
        "host": "Anfitrión"
      },
      "type": {
        "Package": "Entrega de paquetes",
        "Food": "Entrega de comida",
        "Visitor": "Visitante",
        "MeetingAttendee": "Visitante invitado",
        "Employee": "Empleado",
        "Guest": "Visitante"
      }
    },
    "confirmModal": {
      "title": "¿Estás seguro de que quieres registrar la salida de {{fullName}}?",
      "cancel": "Cancelar",
      "checkout": "Registrar salida"
    }
  },
  "wifi": {
    "title": "Conectarse a la red Wi-Fi"
  },
  "door": {
    "external": {
      "title": "Abriendo la puerta",
      "subtitle": "La puerta se abrirá en breve. Por favor espera..."
    },
    "control": {
      "title": "Ahora puedes abrir la puerta",
      "subtitle": "¡Por favor presiona el botón de abajo!",
      "openBtn": "Abrir la puerta"
    },
    "status": {
      "success": {
        "title": "La puerta ha sido abierta",
        "message": ""
      },
      "error": {
        "title": "Algo salió mal",
        "message": "Por favor contacta a tu persona de contacto para abrir la puerta."
      },
      "loading": {
        "title": "Abriendo la puerta...",
        "message": ""
      }
    }
  },
  "photo": {
    "title": "¿Te gustaría tomar una foto como parte de tu proceso de registro?",
    "required": {
      "title": "¡Verificación de foto requerida!",
      "instructions": "Por favor párate frente a la cámara y sigue las instrucciones en pantalla.",
      "securityNotice": "Por motivos de seguridad y verificación, se requiere una foto durante el registro.",
      "privacyInfo": "Respetamos tu privacidad. Tus datos se almacenan de forma segura y se usan solo para identificación.",
      "closingMessage": "Gracias por tu cooperación."
    },
    "optional": {
      "title": "¿Te gustaría tomar una foto como parte de tu proceso de registro?",
      "instructions": "",
      "securityNotice": "Tomar una foto puede ayudar a agilizar la identificación y mejorar la seguridad.",
      "privacyInfo": "Respetamos tu privacidad. Este paso es opcional y tus datos serán manejados de forma segura.",
      "closingMessage": "Puedes omitir este paso si prefieres."
    },
    "subtitle": "Por favor posiciónate dentro del marco y mantente quieto para obtener el mejor resultado",
    "button": {
      "cancel": "Cancelar",
      "accept": "Aceptar",
      "skip": "Omitir",
      "next": "Siguiente",
      "recapture": "Volver a tomar foto",
      "continue": "Continuar"
    },
    "error": "Ocurrió un error al capturar la foto. El proceso de registro continuará sin la foto."
  },
  "wayfinding": {
    "title": "¿A dónde te gustaría ir?"
  },
  "callingMenu": {
    "title": "Menú de llamadas"
  },
  "bell": {
    "status": {
      "success": {
        "title": "El timbre está sonando",
        "message": "Alguien vendrá en breve."
      },
      "error": {
        "title": "Algo salió mal",
        "message": "Inténtelo de nuevo"
      },
      "loading": {
        "title": "Conectando...",
        "message": "Por favor espere"
      }
    }
  },
  "access": {
    "control": {
      "title": "Ahora puedes abrir la puerta",
      "subtitle": "Por favor presiona el botón de abajo.",
      "titleAuto": "Acceso automático a la puerta",
      "subtitleAuto": "La puerta se abrirá automáticamente para ti",
      "openBtn": "Abrir"
    },
    "status": {
      "success": {
        "title": "La puerta ha sido abierta",
        "message": ""
      },
      "error": {
        "title": "Algo salió mal",
        "message": "Por favor contacta a tu persona de contacto para abrir la puerta."
      },
      "loading": {
        "title": "Abriendo la puerta...",
        "message": ""
      }
    }
  }
}
